module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.2093ad12.jpg";